import { j as l } from "../../../node_modules/react/jsx-runtime.js";
import j from "../../atoms/Flex/Flex.js";
import S from "../../atoms/Tooltip/Tooltip.js";
import n from "./SegmentedControl.module.scss.js";
import { clsx as i } from "../../../node_modules/clsx/dist/clsx.m.js";
import { memo as h, useState as N, useEffect as y, useCallback as I } from "react";
import v from "../../atoms/SegmentedControlItem/SegmentedControlItem.js";
const w = (f) => {
  const {
    type: p,
    compact: m,
    defaultSelectedControlItem: c = 0,
    onControlItemClick: o,
    segmentControls: r,
    borderless: g,
    width: u = "fit-content",
    itemWidth: C = "fit-content",
    active: b
  } = f, [s, a] = N(0);
  y(() => {
    a(c);
  }, [c, b]);
  const x = I(
    (e, t) => {
      a(e), o == null || o(e, t);
    },
    [o]
  );
  return /* @__PURE__ */ l.jsx(
    j,
    {
      style: { width: u },
      className: i(n.segmentedControlContainer, {
        [n.compact]: m,
        "!border-0": g
      }),
      children: r == null ? void 0 : r.map((e, t) => {
        const d = {
          ...e,
          selected: s === t
        };
        return /* @__PURE__ */ l.jsx(
          "div",
          {
            className: i(
              n.segmentedControlContainerItem,
              `flex ${C} justify-center w-full`,
              {
                [n.selected]: s === t
              }
            ),
            children: /* @__PURE__ */ l.jsx(
              S,
              {
                placement: "bottom",
                title: e.tooltip,
                trigger: /* @__PURE__ */ l.jsx(
                  v,
                  {
                    label: e.label,
                    iconName: e.iconName,
                    compact: m,
                    type: p,
                    onClick: () => x(t, d),
                    ...d,
                    badge: e.badge
                  }
                )
              },
              t
            )
          }
        );
      })
    }
  );
}, q = h(w);
export {
  q as default
};
//# sourceMappingURL=SegmentedControl.js.map
